
import { useState } from 'react';
import { Link } from 'react-router-dom';

const LogoShowcase = () => {
  const [activeId, setActiveId] = useState<string | null>(null);
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const divisions = [
    {
      id: 'records',
      name: 'Records',
      tagline: 'The Unwound Sound',
      icon: 'ri-disc-line',
      color: '#D97706',
      description: 'Authentic Texas country and Americana releases built to last.',
      link: '/records',
    },
    {
      id: 'publishing',
      name: 'Publishing',
      tagline: 'Songs That Matter',
      icon: 'ri-file-music-line',
      color: '#059669',
      description: 'Protecting and promoting songwriters and their catalogs.',
      link: '/licensing-publishing',
    },
    {
      id: 'licensing',
      name: 'Licensing',
      tagline: 'Music For Media',
      icon: 'ri-film-line',
      color: '#DC2626',
      description: 'Sync placements for film, TV, ads, and digital media.',
      link: '/licensing-publishing',
    },
    {
      id: 'management',
      name: 'Management',
      tagline: 'Artist First',
      icon: 'ri-user-star-line',
      color: '#7C3AED',
      description: 'Career guidance and strategic development for select artists.',
      link: '/management',
    },
  ];

  const handleClick = (id: string) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <section className="bg-cream py-16 sm:py-24 lg:py-32 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-orange-burnt/30 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-orange-burnt/30 to-transparent"></div>
    </section>
  );
};

export default LogoShowcase;
